<template>
  <div class="header-wrapper montserrat-500" :class="bgClass">
    <router-link to="/">
      <img class="logo" alt="LIFT EXPERTS" src="../assets/images/mmcoa-logo.png" />
    </router-link>

    <!-- Burger Icon -->
    <div class="burger" @click="toggleMenu">
      <span></span>
      <span></span>
      <span></span>
    </div>

    <!-- Desktop Nav -->
    <div class="nav-wrapper" :class="{ open: isMenuOpen }">
      <ul>
        <router-link to="/"><li><span :class="fontClass">Home</span></li></router-link>
        <router-link to="/about"><li><span :class="fontClass">About</span></li></router-link>
        <router-link to="/council-members"><li><span :class="fontClass">Council Members</span></li></router-link>
        <router-link to="/news-event"><li><span :class="fontClass">News & Event</span></li></router-link>
        <router-link to="/gallery"><li><span :class="fontClass">Gallery</span></li></router-link>
        <router-link to="/contact-us"><li><span :class="fontClass">Contact</span></li></router-link>
      </ul>
    </div>
  </div>
</template>


<script>
export default {
  name: 'TheHeader',
  props: {
    bgClass: String,
    fontClass: String,
  },
  data() {
    return {
      isMenuOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header-wrapper {
  padding: 2% 5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

/* Logo image */
.logo {
  height: 60px;
}

/* Nav list */
.nav-wrapper ul {
  list-style: none;
  display: flex;
  gap: 20px;
  margin: 0;
  padding: 0;
}

.nav-wrapper ul a  {
  text-decoration: none;
  font-weight: 500;
  color: #000;
}

/* Burger icon styling */
.burger {
  display: none;
  flex-direction: column;
  gap: 5px;
  cursor: pointer;
}

.burger span {
  height: 3px;
  width: 25px;
  background: #000;
  display: block;
  border-radius: 3px;
}

@media screen and (min-width: 570px) {
  .logo {
    height: 50px;
  }
}
@media screen and (min-width: 1070px) {
  .logo {
    height: 80px;
  }
}

/* Responsive */
@media (max-width: 842px) {
  
  .burger {
    display: flex;
  }

  .nav-wrapper {
    position: absolute;
    top: 100%;
    right: 0;
    background: white;
    width: 100%;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
    z-index: 10;
  }

  .nav-wrapper.open {
    max-height: 500px; /* enough to show all items */
  }

  .nav-wrapper ul {
    flex-direction: column;
    gap: 15px;
    padding: 10px 0;
  }
  .nav-wrapper ul li{
    padding: 10px 20px;
    border-bottom: 1px solid #fff200;
  }
}
</style>

